import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPoDetails, getStoreCreditDetails } from "src/api/sp";

export const fetchPoDetails = createAsyncThunk(
  "createOs/fetchPoDetails",
  ({ docId, storeId }: { docId: string; storeId: string }) =>
    getPoDetails({ docId, storeId })
);
export const getStoreCreditDetailsForOS = createAsyncThunk(
  "getStoreCreditDetailsForOS",
  ({
    storeId,
    referenceTransfer,
    type
  }: {
    storeId: string;
    referenceTransfer: number;
    type: string;
  }) => getStoreCreditDetails({ storeId, referenceTransfer, type })
);
